import { InlineFlexPropsType } from "components/basic/flex/style";

export const flexStyle: InlineFlexPropsType = {
    hAlign: "center",
    position: "relative",
    vAlign: "center",
    cursor: 'pointer',
    w: "100%",
    h: "100vh"
};

export const imageStyle = {
    maxWidth: "6rem",
};